import Marquee from "react-fast-marquee";
import { PARTNERS } from "@/data/site";

export const PartnerMarquee = () => {
  return (
    <div className="relative py-4" data-testid="partner-marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#0A0A0A] to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#0A0A0A] to-transparent" />
      <Marquee gradient={false} speed={40} pauseOnHover>
        {PARTNERS.map((p) => (
          <div
            key={p.name}
            className="mx-4 flex items-center justify-center h-16 w-44 rounded-xl bg-white px-6 shadow-sm"
          >
            <img src={p.logo} alt={p.name} className="max-h-9 max-w-full object-contain" />
          </div>
        ))}
      </Marquee>
    </div>
  );
};
